export default "__VITE_ASSET__Cp8p6UDd__"